export default function Layout({ children }) {
  return (
    <div className="min-h-screen bg-[#0f0e0c] flex items-center justify-center">
      <div className="mobile-container">
        {children}
      </div>
    </div>
  );
}
